import React from 'react'
import clsx from 'clsx';
import { Avatar, Container, makeStyles, useTheme } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer'
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { IoMdLogOut } from 'react-icons/io';
import { signOut } from '../../../Firebase/actions/authActions';
import {MdDashboard, MdPublish } from 'react-icons/md';
import {ImProfile } from 'react-icons/im';
import {SiGoogleclassroom} from 'react-icons/si';
import {HiOutlineDocumentRemove} from 'react-icons/hi';


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    page: {
        width: '100%',
        backgroundColor: '#fff'
    },
    root: {
        display: 'flex',
    },
    appBar: {
        
        transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
       
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
    toolbar: theme.mixins.toolbar,
    name : {
        flexGrow: 1,
    },
    avatar : {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(4)
    },
    makeWhite : {
        color: '#fff'
    },
    date: {
        marginLeft: theme.spacing(1),
        textAlign: "center",
        color: '#bbbbbb',
        fontWeight: 'light'
    }

}));


const TeacherLayout = ({ children,  admins, auth, signOut, profile }) => {
    const classes = useStyles()
    const history = useHistory()
    const location = useLocation()
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    var date = moment().format('LL');

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    
    // from db

    const menuItems = [
        {
            text: 'Dashboard',
            icon: <MdDashboard className="main-color-text" size="1.3rem"/>,
            path: '/admin-teacher'
        },
        {
            text: 'Profile',
            icon: <ImProfile className="main-color-text" size="1.3rem"/>,
            path: '/teacher-profile'
        },
        {
            text: 'Add Google Classroom',
            icon: <SiGoogleclassroom  className="main-color-text" size="1.3rem"/>,
            path: '/add-class'
        },
        {
            text: 'Remove Google Classroom',
            icon: <HiOutlineDocumentRemove  className="main-color-text" size="1.3rem"/>,
            path: '/remove-class'
        },
        {
            text: 'Publish Result',
            icon: <MdPublish  className="main-color-text" size="1.3rem"/>,
            path: '/add-result'
        }
    ]

    let output;
    if(auth.uid) {
        let admin;
        
        if (admins) {
            
            admin = admins.filter((item) => {
                return item.id === auth.uid
            });  
            
            output = admin[0];     //console.log(output, auth);
            
        }     
    }

    if(!auth.uid) {
        return <Redirect to="/admin" />
    } else {

        if(profile.idNumber) return <Redirect to="/portal" />

        if(output) {
            if(output.adminLevel !== 'Teacher') return <Redirect to="/admin" />
        }
    }

    return (
        <> 
        {
            output && ( 
                <>
                    
                    <Helmet> 
                        <meta
                            name="description"
                            content="Life Long Polytechnic"
                        />
                        <title>Teacher Portal</title>
                    </Helmet>
                    <div className={classes.root}>
                        <CssBaseline />
                        {/* start app bar */}
                        <AppBar
                            elevation={1}
                            position="fixed"
                            className={clsx(classes.appBar, {
                            [classes.appBarShift]: open,
                            }, 'main-bg')}
                        >
                            <Toolbar>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    className={clsx(classes.menuButton, open && classes.hide)}
                                    
                                >
                                    <MenuIcon />
                                </IconButton>

                                {
                                    !open && (
                                    <>
                                        <Link to="/admin-teacher" className={classes.name}>
                                            <Typography variant="h6" className="grey-text text-lighten-3 hide-on-small-only">
                                                Life Long Polytechnic /  Dashboard
                                            </Typography>
                                        </Link>  
                                        <Typography>
                                            {output.title} {output.surname}
                                        </Typography>
                                        <Avatar  src={output.imageUrl} className={classes.avatar}/>
                                    </>
                                    )
                                }
                                    
                                
                            </Toolbar>
                        </AppBar>
                        {/* end app bar */}

                        {/* start drawer */}
                        <Drawer
                            className={classes.drawer}
                            variant="persistent"
                            anchor="left"
                            open={open}
                            classes={{
                            paper: classes.drawerPaper,
                            }}
                        >
                            <div className={classes.drawerHeader}>
                                <IconButton onClick={handleDrawerClose}>
                                    {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                                </IconButton>
                            </div>
                            {/* links/list section */}
                            <Typography variant="subtitle2" className={classes.date}>
                                {date}
                            </Typography>
                            <List>
                                {menuItems.map((item) => (
                                    <ListItem 
                                        button 
                                        key={item.text} 
                                        onClick={() => history.push(item.path)}
                                        className={location.pathname === item.path ? classes.active : null}
                                    >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.text} />
                                    </ListItem>
                                ))}
                                <ListItem 
                                    button 
                                    onClick={() => signOut()}
                                >
                                    <ListItemIcon>
                                        <IoMdLogOut className="main-color-text" size="1.2rem"/>
                                    </ListItemIcon>
                                    <ListItemText primary='Log Out' />
                                </ListItem>
                            </List>
                        </Drawer>
                        {/* end drawer */}
                        
                        {/* main */}
                        <div className={classes.page} >
                            <div className={classes.toolbar}></div>
                            <div className="light-bg wrapper">
                                <Container>
                                    { children }
                                </Container>
                            </div>
                        </div>
                        {/* end main */}
                    </div>
                </>
            )
        }
        </>
     );
}

const mapStateToProps = (state) => {
    //console.log(state)
    return {
        profile: state.firebase.profile,
        admins: state.firestore.ordered.admins,
        auth: state.firebase.auth,
    }
    
}

const mapDispatchToProps = (dispatch) => { 
    return {
        signOut: () => dispatch(signOut())
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "admins", 
            },
    ])
)(TeacherLayout);